// import { SubmissionError } from 'redux-form'
import keys from 'lodash/keys'
import each from 'lodash/forEach'
import storage from 'store2'
import { serializeData, getCookie } from './utils'
import { toast } from 'react-toastify'
import get from 'lodash/get'

let domain = process.env.DOMAIN

if(window.location.href.search('travel.localhost') !== -1 && !storage('testMode')) {
  domain = 'http://travel.localhost'
}

// FIXME make it as middleware
export function configure(s) {
  store = s

  // store.dispatch(success({token: 'dsafas'}));
}

export default function(endpoint, signal, addTokenToRequest, endpointAsUrl) {
  return new API(endpoint, signal, addTokenToRequest, endpointAsUrl)
}

class API {
  constructor(endpoint, signal, addTokenToRequest, endpointAsUrl) {
    this.endpoint = endpoint
    this.signal = signal || undefined
    this.addTokenToRequest = addTokenToRequest
    this.endpointAsUrl = endpointAsUrl
  }

  getUrl() {
    return this.endpointAsUrl ? this.endpoint : `${domain}/api/v2/travel/${this.endpoint}`
  }

  request(method = 'GET', data, options = {}) {
    const authToken = storage('token')
    const Authorization = authToken && this.addTokenToRequest ? 'JWT ' + authToken : ''

    let url = this.getUrl()

    if(method === 'GET' && data) {
      url += `?${serializeData(data)}`
    }

    let headers = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRFToken': getCookie('csrftoken'),
      Authorization,
    }

    if(options.isFormData) {
      let {
        'Content-Type': toDelete, ...newHeaders
      } = headers
      headers = newHeaders
      var formData = new FormData()

      for(let name in data) {
        formData.append(name, data[name])
      }
    }
    return fetch(url,
      {
        method,
        body: data && method !== 'GET' ? (options.isFormData ? formData : JSON.stringify(data)) : undefined,
        headers,
        signal: this.signal,
        credentials: 'include',
      }
    )
      .then(response => {
        if(response.status === 500) {
          throw new Error('500')
        }

        if(response.status === 401) {
          // store.dispatch(logout());
          localStorage.removeItem('user')
          localStorage.removeItem('token')

        //   if (window.location.pathname.search(createURL('login')) >= 0) {
        //     store.dispatch(push(createURL('login')));
        //     window.location.reload();
        //   }
        }

        if(response.status === 403) {
          throw new Error('403')
        }

        if(response.status === 404) {
          if(this.notFoundEror) {
            throw new SubmissionError(this.notFoundEror)
          }
          // notification.error({
          //   message: 'Not found',
          //   style: {
          //     width: 300,
          //     textTransform: 'uppercase',
          //     marginLeft: 335 - 300,
          //   },
          // });
          throw new Error('404')
        }

        if(response.status === 204 || (response.headers && response.headers.get('Content-Type').search('application/json') === -1)) {
          return response
        }

        return response.json()
          .then(function(body) {
            if(response.ok) {
              return body
            }
            let eKey
            // handle errors
            let errors = {}

            keys(body).forEach(key => {
              eKey = key
              if(key === 'nonFieldErrors' || key === 'detail' || key === 'errors') {
                eKey = '_error'
              }

              if(eKey === 'nonFieldErrors') {
                errors[eKey] = body[key][0]
              } else if(Array.isArray(body[key])) {
                each(body[key], (v, k) => {
                  if(!errors[key]) {
                    errors[key] = []
                  }

                  if(v.nonFieldErrors) {
                    v = {
                      _error: v.nonFieldErrors[0],
                    }
                  }

                  errors[key].push(v)
                })
              } else {
                errors[eKey] = body[key]
              }
            })
            throw toast.error(get(errors[eKey], '[0]', errors[eKey]) || 'Something went wrong', {
              position: toast.POSITION.TOP_CENTER,
            })
          })
      })
  }

  postAsFormData(data) {
    return this.request('POST', data, { isFormData: true })
  }

  patchAsFormData(data) {
    return this.request('PATCH', data, { isFormData: true })
  }

  putAsFormData(data) {
    return this.request('PUT', data, { isFormData: true })
  }

  post(data) {
    return this.request('POST', data)
  }
  delete(data) {
    return this.request('DELETE', data)
  }
  patch(data) {
    return this.request('PATCH', data)
  }
  put(data) {
    return this.request('PUT', data)
  }
  get(data) {
    return this.request('GET', data)
  }
  set404ErrorMsg(error) {
    this.notFoundEror = error

    return this
  }

  all(requests) {
    return Promise.all(requests).catch(body => {
      let errorText = ''

      each(body.errors, (val, key) => {
        errorText += `${key} - ${val}. `
      })

      throw new SubmissionError(body.errors)
    })
  }
}
